export default "__VITE_ASSET__7d534a9e__"